import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getApiUrl } from "../services/api_service";
import { saveAs } from "file-saver";
import Footer from "../components/shared/footer";
import {
  Typography,
  Paper,
  Box,
  
  CssBaseline,
  AppBar,
  Toolbar,
  
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import MetaDecorator from "../services/meta_decorator";

import Textfield from "../components/shared/textfield";
import { bodyBg, darkcolor, fullHeight, pcolor, rcolor, registrationHeader } from "../style2";



export default function DownloadForm(props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { id } = useParams();
  const [nhsNumber, setNhsNumber] = useState('');
  
  const [pin, setPin] = useState('');
  
  const button = {
    width: 140,
    height: 40,
    background: rcolor,
    border: "1px solid " + rcolor,
    boxSizing: "border-box",
    borderRadius: 2,
    textTransform: "unset",
    color: "#FFFFFF",
    "&:hover": {
      color: darkcolor,
      background: rcolor,
    },
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getData = () => {
    if (nhsNumber === "") {
      setError("NHS Number is required.");
      return;
    }
    if (pin === "") {
      setError("Secure Pin is required.");
      return;
    }
    setError("");
    setLoading(true);
    fetch(
      `${getApiUrl()}/patientform/download`,
      {
        method: "POST",
        body: JSON.stringify({ id, pin, nhs: nhsNumber }),
        headers: { 'Content-Type': 'application/json' },
      }
    )
      .then((response) => {
        if (response.status === 200) {

          response.blob().then(blob => {
            const contentDisposition = response.headers.get('content-disposition');
            let filename = 'form.docx';
            if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(contentDisposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
              }
            }
            saveAs(blob, filename);
          });
        } else {
          response.json().then(data => {
            
            setError(data.error);
          }).catch(err => {
            console.log(err);
            setError("An error occured");
          });
        }
      }).catch(err => {
        setError("Unable to contact server.");
      }).finally(() => {
        setLoading(false);
      });
  };

  return <Box sx={{...bodyBg, ...fullHeight}}>
    <CssBaseline />
    <MetaDecorator
      title={"EnrichMyCare - Download Form"}
      description={"Download Answered Form"}
    />
    <AppBar sx={{
      position: "static",
      background: "#ffffff",
      boxShadow: "none"
    }}>
      <Toolbar sx={{
        minHeight: 100,
        marginLeft: "auto",
        marginRight: "auto"
      }}>
        <Box component="img"
          sx={registrationHeader}
          src='../Logo_Option_1.svg'
          alt='logo'
        ></Box>
      </Toolbar>
    </AppBar>
    <Box pt={1} sx={{...bodyBg, maxWidth: "40%", margin: "0 auto", marginTop: "5px" }}>
      <Typography sx={{ color: pcolor, textAlign: "center", fontSize: "1.7rem", fontWeight: "bold", marginTop: 30, marginBottom: 10 }} >Download Form</Typography>
      {/* <Box style={{ textAlign: "center", paddingBottom: 15 }}>
        <Chip label="Empowering clinicians" variant="outlined" style={{ background: "#fff", color: pcolor, marginRight: 20 }} />
        <Chip label="Saving time" variant="outlined" style={{ background: "#fff", color: pcolor, marginRight: 20 }} />
        <Chip label="Actionable data" variant="outlined" style={{ background: "#fff", color: pcolor, marginRight: 20 }} />
        <Chip label="Care coordination" variant="outlined" style={{ background: "#fff", color: pcolor, marginRight: 20 }} />
        <Chip label="Enhancing proactive care " variant="outlined" style={{ background: "#fff", color: pcolor }} />
      </Box> */}
      <Paper>
        <Box pb={2} sx={{ maxWidth: "90%", margin: "0 auto" }}>
          <form onSubmit={(e) => { e.preventDefault(); getData(); }}>
            <Box item xs={12} paddingTop={3}>
              <Textfield title={"NHS Number *"} id={"nhsnumbertxt"} required={true}
                value={nhsNumber} name={"nhsnumber"} onChange={(e) => { setNhsNumber(e.target.value) }}
                maxCharacterLimit={14}
              />
            </Box>
            <Box item xs={12} paddingTop={3}>
              <Textfield title={"Secure Pin *"} id="securepintxt" required={true} maxCharacterLimit={100} value={pin} onChange={(e) => {
                setPin(e.target.value);
              }} />
            </Box>
            {error !== "" ? <Typography style={{ color: "red", padding: "5px", textAlign: "center" }}>{error}</Typography> : null}
            <Box item xs={12} align="center" paddingTop={3}>
              <LoadingButton loading={loading} sx={{ ...button }} type="submit">
                Download
              </LoadingButton>
            </Box>
          </form>
        </Box>
      </Paper>

    </Box>
    {/* <Box style={{ marginTop: 20 }}>
      <table style={{ maxWidth: '80%', margin: "0 auto" }}>
        <tbody>
          <tr>
            <td style={{ width: "20%" }} align="center">
              <img src='../cyber-essential-seal.png' style={{ width: 45, height: "auto" }} />
            </td>
            <td style={{ width: "20%" }} align="center"><img alt="" src='../ico-logo.png' style={{ width: 70, height: "auto" }} /></td>
            <td style={{ width: "20%" }} align="center"><img alt="" src='../dcb-seal.png' style={{ height: 50 }} /></td>
            <td style={{ width: "20%" }} align="center"><img alt="" src='../orcha.png' style={{ height: 50 }} /></td>
            <td style={{ width: "20%" }} align="center"><img alt="" src='../oxford-university-hospitals.png' style={{ height: 50 }} /></td>
          </tr>
        </tbody>
      </table>
    </Box> */}
    <Box style={{ background: "#fff", position: "fixed", bottom: "0", width: "100%", textAlign: "center" }}>
      <Footer />
    </Box>
  </Box>;
}